/** Address autocomplete field using Google Places **/

const options = {
  componentRestrictions: { country: 'us' },
  fields: ['address_components', 'geometry', 'utc_offset_minutes'],
  types: ['address'],
};

const setValue = (parentForm, attr, value) => {
  // set a value if a field is present in the parent form (normally hidden)
  // matching our naming convention
  // - street
  // - city
  // - state
  // - country
  // - postal-code
  // - lat
  // - lon
  const fieldEl = parentForm.querySelector(`[name="${attr}"]`);
  if (fieldEl) {
    fieldEl.value = value;
  }
};

const addressAutocomplete = ({ fieldEl }) => {
  const parentForm = fieldEl.closest('form');
  const ac = new window.google.maps.places.Autocomplete(
    fieldEl, options
  );
  ac.addListener('place_changed', async () => {
    const place = await ac.getPlace();
    console.log('place', place);

    // set latitude and longitude
    setValue(parentForm, 'lat', place.geometry.location.lat());
    setValue(parentForm, 'lon', place.geometry.location.lng());

    // setting values
    let streetNumber = '';
    let route = '';
    for (const address_component of place.address_components) {
      if (address_component.types.includes("postal_code")) {
        setValue(parentForm, 'postal-code', address_component.long_name);
      }
      if (address_component.types.includes("street_number")) {
        streetNumber = address_component.long_name;
      }
      if (address_component.types.includes("route")) {
        route = address_component.long_name;
      }

      let localitySet = false;  // status of if we have already determined the locality/street
      if (address_component.types.includes("locality")) {
        setValue(parentForm, 'city', address_component.long_name);
        localitySet = true;
      } else if (address_component.types.includes("sublocality") && !localitySet) {
        setValue(parentForm, 'city', address_component.long_name);
        localitySet = true;
      } else if (address_component.types.includes("administrative_area_level_3") && !localitySet) {
        setValue(parentForm, 'city', address_component.long_name);
      }
      if (address_component.types.includes("administrative_area_level_1")) {
        setValue(parentForm, 'state', address_component.short_name);
      }
      if (address_component.types.includes("country")) {
        setValue(parentForm, 'country', address_component.short_name);
      }
    };
    setValue(parentForm, 'street', `${streetNumber} ${route}`);
  });
}

// code should execute when not testing
if (window.sb && window.sb.test !== true) {
  // assign to window for use in other functions
  window.addressAutocomplete = addressAutocomplete;
}